<template>
  <div class="home-memu">
    <dl @click="$router.push('/Fans')">
      <dt>
        <img src="../../assets/images/home-img/3.png" alt="">
      </dt>
      <dd>
        用户管理
      </dd>
    </dl>
    <img src="../../assets/images/home-img/11.png" alt="" class="line">
    <dl @click="marketing_btn">
      <dt>
        <img src="../../assets/images/home-img/4.png" alt="">
      </dt>
      <dd>
        会员营销
      </dd>
    </dl>
    <img src="../../assets/images/home-img/11.png" alt="" class="line">
    <dl @click="data_btn">
      <dt>
        <img src="../../assets/images/home-img/10.png" alt="">
      </dt>
      <dd>
        数据管理
      </dd>
    </dl>
    <img src="../../assets/images/home-img/11.png" alt="" class="line">
    <dl @click="$router.push('/my')">
      <dt>
        <img src="../../assets/images/home-img/5.png" alt="">
      </dt>
      <dd>
        个人中心
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  data(){
    return{
      uid : '',
      partent_msg : [], // 申请合伙人状态
      card_msg: '', // 会员卡状态
    }
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));
    // 申请合伙人状态
    this.$axios.post(this.domain.url + '/api/dcash/index/balance',{
      uid : this.uid
    }).then((res) => {
      // console.log(res.data.data)
      this.partent_msg = res.data.data
    })
    // 会员状态
    this.$axios.post(this.domain.url + '/api/user/index/is_member',{
      uid : this.uid
    }).then((res) =>{
      // console.log(res.data.data)
      this.card_msg = res.data.data
    })
  },
  methods:{
    // 营销中心
    marketing_btn(){
      if(this.card_msg == 1){
        if(this.partent_msg.is_partner == 0){
          this.$router.push('/write-msg')
        }else if(this.partent_msg.is_partner == 1){
          this.$router.push('/authentication')
        }else if(this.partent_msg.is_partner == 2){
          this.$router.push('/partner-information')
        }
      }else if(this.card_msg == 0){
        this.$router.push({
          path: '/card-ecommend',
          query:{
            card_id : 1
          }
        })
      }
    },
    // 数据管理
    data_btn(){
      this.$axios.post(this.domain.url + '/api/user/index/operational_staff',{
        uid : this.uid
      }).then((res) =>{
        // console.log(res.data.data)
        if(res.data.data == 1){
          this.$router.push('/admin-data')
        }else{
          this.$router.push('/user-data')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .home-memu{
    width: 7.16rem;
    height: 1.86rem;
    background: #fff;
    border-radius: .1rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    dl{
      width: 24.5%;
      height: .99rem;
      text-align: center;
      &:nth-child(2){
        dt{
          img{
            width: .61rem;
            height: .61rem;
          }
        }
      }
      &:nth-child(3){
        dt{
          img{
            width: .54rem;
            height: .58rem;
          }
        }
      }
      &:last-child{
        dt{
          img{
            width: .54rem;
            height: .64rem;
          }
        }
      }
      dt{
        img{
          width: .5rem;
          height: .62rem;
        }
      }
      dd{
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #0C0C0C;
      }
    }
    .line{
      width: .02rem;
      height: .99rem;
    }
  }
</style>